export default function addImageToLocalStorage(storagename, image_date, image){
   
    let currentLocalStorage = localStorage.getItem(storagename);
    currentLocalStorage = currentLocalStorage ? JSON.parse(currentLocalStorage) : {};
    currentLocalStorage[image_date] = image;
    localStorage.setItem(storagename, JSON.stringify(currentLocalStorage));
    // console.table(JSON.parse(localStorage.getItem(storagename)));
    return JSON.parse(localStorage.getItem(storagename))
}